export default __webpack_public_path__ + "dist/media/Section 3.950ca9f5.png";